import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import Subscription from '../../models/Subscription';
import { UserRole } from '@leedpulse-monorepo/enums';
import { Authentication } from '@leedpulse-monorepo/classes';
import { IContact } from '@leedpulse-monorepo/interfaces';

async function sendMessage(
  contact: IContact,
  subscription: Subscription,
  message: string,
  auth: Authentication
): Promise<void> {
  if (
    ![UserRole.owner, UserRole.admin, UserRole.maintainer].includes(auth.role)
  ) {
    throw new SendMessageFailure('Unauthorized', 'unauthorized');
  }
  try {
    await HttpClient.post(
      '/sms/send',
      {
        msg: message,
        manualsending: true,
      },
      auth.token,
      false,
      {
        'x-user-email': auth.email,
        'x-api-key': contact.id_api_key,
        'x-phone': contact.contact.phone,
        'x-sender':
          contact.contact.sender === ''
            ? subscription.sender[0]
            : contact.contact.sender,
      }
    );
    return;
  } catch (e) {
    console.log('error: ', e);
    throw new SendMessageFailure();
  }
}

export class SendMessageFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default sendMessage;
